import 'datatables.net-buttons/js/buttons.colVis'

$.extend($.fn.dataTable.ext.buttons, {
    customColvis: {
        extend: 'colvis',
        text: '<i class="fa-regular fa-line-columns"></i>',
        className: 'arrow-none',
        columnText: function ( dt, idx, title ) {
            return '<i class="fas fa-check icon-check"></i>'+title;
        },
    }
})
